<template>
  <div id="app">
    <header class="page-row">
      <headers ref="headersContainer" v-if="notInCountdown"></headers>
    </header>

    <main class="page-row page-row-expanded">
      <transition mode="out-in" name="fade">
        <router-view id="mainPage" ref="routerContainer"></router-view>
      </transition>
    </main>

    <footer class="page-row">
      <MainFooter v-if="notInCountdown"></MainFooter>
    </footer>
  </div>
</template>

<script>
  import Headers from './components/headerComponents/Headers'
  import MainFooter from './components/footerComponents/MainFooter'
  import {mapGetters} from 'vuex'

  export default {
    name: 'app',
    components: {Headers, MainFooter},
    mounted: function () {
      // this.checkForDate()
      if (this.notInCountdown) {
        let self = this
        window.onscroll = function () {
          self.$refs.headersContainer.stickyAndDisappear()
          self.leaveSpace()
        }
      }

      if (this.$route.params.language) {
        switch (this.$route.params.language.toLowerCase()) {
          case 'italian':
            this.setItalianLanguage()
            break
          case 'english':
            this.setEnglishLanguage()
            break
          case 'german':
            this.setGermanLanguage()
            break
          case 'french':
            this.setFrenchLanguage()
            break
          case 'slovenian':
            this.setSlovenianLanguage()
            break
          default:
            this.setItalianLanguage()
        }
      } else {
        this.setItalianLanguage()
      }
    },
    created: function () {
      // console.log('Preview mode: ' + this.$store.getters.isPreviewModeValue)
      if (document.getElementById('mobile-meta-tag-counter')) {
        document.getElementsByTagName('head')[0].removeChild(document.getElementById('mobile-meta-tag-counter'))
      }
      let meta = document.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'
      meta.id = 'mobile-meta-tag'
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    computed: {
      ...mapGetters({
        currentView: 'currentViewValue'
      }),
      notInCountdown () {
        return this.currentView.name !== 'CountdownPanel'
      }
    },
    methods: {
      // checkForDate () {
      //   if ((!this.$store.getters.isPreviewModeValue) && this.isPastRelaseDate && this.$PATH_NAME !== 'http://localhost:8080/') {
      //     this.$router.push('/countdown')
      //   }
      // },
      leaveSpace () {
        let header = document.getElementById('headersWrapper')
        let container = document.getElementById('mainPage')
        let sticky = header.offsetTop
        if (window.pageYOffset > sticky) {
          if (this.$store.getters.isMobileValue) {
            container.classList.add('spacing-mobile')
          } else {
            container.classList.add('spacing')
          }
        } else {
          if (this.$store.getters.isMobileValue) {
            container.classList.remove('spacing-mobile')
          } else {
            container.classList.remove('spacing')
          }
        }
      },
      isPastRelaseDate () {
        return (Math.trunc(Date.parse('October 4, 2018 16:00:00') / 1000) - Math.trunc(new Date().getTime() / 1000)) > 0
      }
    },
    updated: function () {
      // this.checkForDate()
    }
  }
</script>

<style>

  p {
    margin: 0;
    padding: 0 0 1em 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  .title-container {
    /*border-bottom: solid 1px grey;*/
    border-bottom: 1px solid #bdbdbd;
    /*width: 68%;*/
    left: 0;
    right: 0;
    margin: auto 20% 2.5%;
    color: #c41c21;
  }

  @media only screen and (max-width: 600px) {
    .title-container {
      margin: 0 0 2.5%;
    }

    .title-container > h1 {
      font-size: 1.5rem !important;
    }

    .title-container > h2 {
      font-size: 1.3rem !important;
    }
  }

  h1 {
    color: #c41c21;
  }

  html {
    height: 100%;
    box-sizing: border-box;
    margin: 0 !important;
  }

  body {
    width: 100%;
    position: relative;
    margin: 0 !important;
    font-family: "Helvetica Neue", Arial, sans-serif;
    height: 100%;
    overflow-x: hidden;
  }

  #app {
    width: 100%;
    height: 100%;
    font-family: 'Lato', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 0;
    display: table;
  }

  .page-row {
    display: table-row;
    width: 100%;
    height: 1px;
  }

  .page-row-expanded {
    height: 100%;
  }

  .spacing-mobile {
    padding-top: 40%;
  }

  .spacing {
    padding-top: 6%;
  }

  #mainPage {
    margin: 2% 0;
  }

  .f-title > h1 {
    font-family: 'Ubuntu Mono', sans-serif;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 700;
    font-size: 5em;
    line-height: 1.2em;
    text-align: center;
    width: 100%;
    margin: 0;
    padding: 0
  }

  .f-title {
    position: fixed;
    top: 20%;
    margin-top: -9em;
    width: 100%;
    background-color: rgba(135, 206, 250, 0.5);
    padding: 0;
  }

  .empty-box {
    width: 8em;
    display: inline-block;
    height: 7em;
    background-size: contain;
    vertical-align: text-bottom;
    background: url("data:image/svg+xml;utf8;base64,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") no-repeat;
  }

  .contest-photo {
    width: 8em;
    display: inline-block;
    height: 8em;
    background-size: contain;
    vertical-align: text-bottom;
    background: url("assets/camera.svg") no-repeat;
    /*background: url("https://i.imgur.com/um94Nto.png") no-repeat;*/
  }

</style>



// WEBPACK FOOTER //
// src/App.vue